import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

const StockItemTermsComponent = ({
  hasAgreedStockTerms,
  onHasAgreedStockTermsChange,
}) => (
  <div>
    <div className="hr-divider">
      <h3 className="hr-divider-content hr-divider-heading">Stock Items</h3>
    </div>
    <div>
      <div
        className={`alert alert-warning text-center w-100 ${
          hasAgreedStockTerms ? '' : 'highlighted'
        }`}
      >
        <strong>
          Stock items are subject to availability and are not guaranteed until
          the time of order.
        </strong>
        <br />
        <strong>
          When stock becomes unavailable, this product will be converted to a
          build to order item with standard lead times.
        </strong>
        <br />
        <br />
        <strong>I agree to the above terms</strong>
        <Toggle
          className="align-middle ms-3 mt-1"
          checked={hasAgreedStockTerms}
          onChange={(e) => onHasAgreedStockTermsChange(e.target.checked)}
        />
      </div>
    </div>
  </div>
);

StockItemTermsComponent.propTypes = {
  hasAgreedStockTerms: PropTypes.bool.isRequired,
  onHasAgreedStockTermsChange: PropTypes.func.isRequired,
};

export default StockItemTermsComponent;
